export const SOURCE_LOCALE = "en" as const;
export const PSEUDO_LOCALE = "en-XA" as const;

export const SUPPORTED_LOCALES = ["en", "fr-FR", "en-XA"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

const RTL_LOCALES = new Set<string>(["ar", "he"]);

export const isSupportedLocale = (value: unknown): value is SupportedLocale =>
  typeof value === "string" && (SUPPORTED_LOCALES as readonly string[]).includes(value);

export const isRtlLocale = (locale: string): boolean => RTL_LOCALES.has(locale);
